import { observable, runInAction } from 'mobx';
import {
  AddTestTarget,
  EditTestTarget,
  ITestTargetServices,
  TestTarget,
} from 'services/testTarget_services';

export type TestTargetStore = {
  testTarget: {
    data: Array<TestTarget>;
    message: string;
    isSuccess: boolean;
    recordsTotal: number;
    resultsCount: number;
    pagesCount: number;
  };
  createResponse: {
    message?: string;
    isSuccess?: boolean;
    errors?: {
      StepCode: string[];
      TargetName: string[];
    };
  };
  updateResponse: {
    message: string;
    isSuccess: boolean;
  };
  testTargetByID: {
    isSuccess: boolean;
    data: TestTarget | undefined;
    message: string;
  };
};
export interface ITestTargetPresenter {
  createStore(): TestTargetStore;
  getListTestTarget(store: TestTargetStore, data: object): Promise<void>;
  createTestTarget(store: TestTargetStore, data: AddTestTarget): Promise<void>;
  updateTestTarget(store: TestTargetStore, data: EditTestTarget): Promise<void>;
  getTestTargetById(store: TestTargetStore, id: string): Promise<void>;
}

export function createTestTargetPresenter({
  testTargetServices,
}: {
  testTargetServices: ITestTargetServices;
}): ITestTargetPresenter {
  return {
    createStore: (): TestTargetStore =>
      observable({
        testTarget: {
          data: [],
          message: '',
          isSuccess: false,
          recordsTotal: 0,
          resultsCount: 0,
          pagesCount: 0,
        },
        createResponse: {
          message: '',
          isSuccess: false,
          errors: {
            StepCode: [],
            TargetName: [],
          },
        },
        updateResponse: {
          message: '',
          isSuccess: false,
        },
        testTargetByID: {
          data: {
            stt: 0,
            testTargetId: '',
            targetCode: 0,
            targetName: '',
            stepCode: '',
            stepName: '',
            actived: false,
            tolerance: '',
            isQualityIndiCation: false,
            requiredByWO: false,
            requiredByWOCard: false,
            standard: '',
          },
          message: '',
          isSuccess: false,
        },
      }),
    getListTestTarget: async (store, data) => {
      try {
        const testTargets = await testTargetServices.getList(data);

        runInAction(() => {
          store.testTarget.data = testTargets.data;
          store.testTarget.pagesCount = testTargets.pagesCount;
          store.testTarget.resultsCount = testTargets.resultsCount;
          store.testTarget.recordsTotal = testTargets.recordsTotal;
          store.testTarget.isSuccess = testTargets.isSuccess;
          store.testTarget.message = testTargets.message;
        });
      } catch (error) {
        console.log(error);
      }
    },
    createTestTarget: async (store, data) => {
      try {
        const createTestTarget = await testTargetServices.createTestTarget(
          data
        );
        runInAction(() => {
          store.createResponse.isSuccess = createTestTarget.isSuccess;
          store.createResponse.message = createTestTarget.message;
          store.createResponse.errors = createTestTarget.errors;
        });
      } catch (error) {
        console.log(error);
      }
    },
    updateTestTarget: async (store, data) => {
      try {
        const updateTestTarget = await testTargetServices.updateTestTarget(
          data
        );
        runInAction(() => {
          store.testTargetByID.data = updateTestTarget.data;
          store.updateResponse.isSuccess = updateTestTarget.isSuccess;
          store.updateResponse.message = updateTestTarget.message;
        });
      } catch (error) {
        console.log(error);
      }
    },
    getTestTargetById: async (store, id) => {
      try {
        const result = await testTargetServices.getTestTargetById(id);
        runInAction(() => {
          store.testTargetByID.data = result.data;
          store.testTargetByID.data.actived = result.data.actived;
        });
      } catch (error) {
        console.log(error);
      }
    },
  };
}
